export default {
  SET_ITEMS(state, payload) {
    state.avis = payload
  },

  ADD_ITEM(state, payload) {
    state.avis.push(payload)
  },

  UPDATE_ITEM(state, payload) {
    const ItemIndex = state.avis.findIndex(p => p.id == payload.id)
    Object.assign(state.avis[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
    const ItemIndex = state.avis.findIndex(p => p.id == itemId)
    state.avis.splice(ItemIndex, 1)
  },

}
